import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgItFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53531)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.6662 41.3788H0.861621C0.385547 41.3788 -0.000488281 40.9928 -0.000488281 40.5167V9.48223C-0.000488281 9.00615 0.385547 8.62012 0.861621 8.62012H16.6662V41.3788Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.3335 8.62061H16.6665V41.3794H33.3335V8.62061Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1371 41.3787H33.3325V8.62012H49.1371C49.6132 8.62012 49.9992 9.00615 49.9992 9.48223V40.5167C49.9992 40.9929 49.6132 41.3787 49.1371 41.3787Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53531",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgItFlag);
export { ForwardRef as ReactComponent };
